import { useState } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    FormControl,
    FormLabel,
    Input,
} from "@chakra-ui/react";
import { LoadingSpinner } from "../components/base/loading-spinner/loading-spinner.comp";

type CreateOrgInviteCodeModalProps = {
    isOpen: boolean;
    handleCreate: (code: string) => Promise<void>;
    closeModal: () => void;
};

export const CreateOrgInviteCodeModal = ({
    isOpen,
    handleCreate,
    closeModal,
}: CreateOrgInviteCodeModalProps) => {
    const [code, setCode] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async () => {
        try {
            if (!code.trim()) {
                return;
            }
            setIsLoading(true);
            await handleCreate(code);
        } catch (error) {

        } finally {
            setIsLoading(false);
            onCloseModal();
        }
    };

    const onCloseModal = () => {
        setCode("");
        closeModal();
    };

    return (
        <Modal isOpen={isOpen} onClose={onCloseModal}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{"Create Code"}</ModalHeader>
                <ModalCloseButton />
                {!isLoading ? <ModalBody>
                    <FormControl mb={4}>
                        <FormLabel htmlFor="code">Code</FormLabel>
                        <Input
                            id="code"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            placeholder="Enter code"
                        />
                    </FormControl>
                </ModalBody> : <LoadingSpinner />}

                <ModalFooter>
                    <Button isDisabled={isLoading} variant="outline" onClick={onCloseModal}>
                        Close
                    </Button>
                    <Button isDisabled={!code.trim()} colorScheme="teal" ml={3} onClick={handleSubmit}>
                        {"Submit"}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
